import {
  NOTE_DARK_INK,
  NOTE_DEEP_SHADE,
  NOTE_GLOW_ALPHA,
  NOTE_LIGHT_FRAME_LUMINANCE,
  NOTE_LIGHT_INK,
  NOTE_PILL_ALPHA,
} from "./constants";
import type { NoteColorsOf } from "./types";

export const noteColorsOf: NoteColorsOf = ([red, green, blue]) => {
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
  const darken = (channel: number) => Math.round(channel * NOTE_DEEP_SHADE);
  return {
    frame: `rgb(${red}, ${green}, ${blue})`,
    ink:
      luminance > NOTE_LIGHT_FRAME_LUMINANCE ? NOTE_DARK_INK : NOTE_LIGHT_INK,
    glow: `rgba(${red}, ${green}, ${blue}, ${NOTE_GLOW_ALPHA})`,
    pill: `rgba(${red}, ${green}, ${blue}, ${NOTE_PILL_ALPHA})`,
    deep: `rgb(${darken(red)}, ${darken(green)}, ${darken(blue)})`,
  };
};
